export default __webpack_public_path__ + "static/media/keypad.e5380826.svg";